<template>
  <!-- <section id="sectionFooter" class="footer-sections">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-4 footer-info">
          <span class="footer-head d-block">Contact us</span>
          <ul class="contact-info">
            <li>
              <a href="mailto:info@kipsvirtual.com">info@kipsvirtual.com</a>
            </li>
            <li><a href="tel:042111547775">(042) 111 547 775</a></li>
            <li>
              <a href="https://goo.gl/maps/M24HR1tHXdEApySZ8" target="_blank">
                5/6, D-1 Khayaban-e-Firdousi, Johar Town Lahore, Pakistan</a>
            </li>
          </ul>
          <div class="footer-icons">
            <a href="http://www.facebook.com/kipsvirtual" target="_blank">
              <img src="/assets/images/facebook.svg" alt="" width="19" height="19">
            </a>
            <a href="http://www.instagram.com/kipsvirtual" target="_blank">
              <img src="/assets/images/instagram.svg" alt="" width="19" height="19">
            </a>
            <a href="https://www.youtube.com/@KIPSVirtual" target="_blank">
              <img src="/assets/images/youtube.svg" alt="" width="19" height="19">

            </a>
            <a href="https://www.tiktok.com/@kipsvirtual?_t=8nlOXUVGXdh&_r=1" target="_blank">
              <img src="/assets/images/tiktok.svg" alt="" width="19" height="19">
            </a>
          </div>
        </div>

        <div class="col-md-6 col-lg-4 footer-info">
          <span class="footer-head d-block">Useful links</span>
          <ul class="footer-links">
            <li>
              <router-link class="footer-links" to="/category">Enroll</router-link>
            </li>
            <li>
              <router-link class="footer-links" to="/popularPrograms">Featured Programs</router-link>
            </li>
            <li>
              <router-link class="footer-links" to="/faq">FAQs</router-link>
            </li>
           
            <li>
              <router-link class="footer-links" to="/blogs">Blogs</router-link>
            </li>
           
          </ul>
        </div>

        <div class="col-md-6 col-lg-4 footer-info">
          <span class="footer-head d-block">KIPS Projects</span>
          <ul class="footer-links">
            <li>
              <a class="footer-links" target="_blank" href="https://kips.edu.pk/">KIPS Education System</a>
            </li>
            <li>
              <a class="footer-links" target="_blank" href="https://kipspublications.com/">KIPS Publicatons</a>
            </li>
            <li>
              <a class="footer-links" target="_blank" href="https://kipsschool.com/">KIPS School</a>
            </li>
            <li>
              <a class="footer-links" target="_blank" href="https://7csschool.com/">7Cs School</a>
            </li>
            <li>
              <a class="footer-links" target="_blank" href="https://kipscolleges.com/">KIPS College</a>
            </li>
            <li>
              <a class="footer-links" href="#keys-academy">KEYS Academy</a>
            </li>
            <li>
              <a class="footer-links" target="_blank" href="https://kipsprep.com/">KIPS Preprations</a>
            </li>
            <li>
              <a class="footer-links" target="_blank" href="https://qb-franchising.com/">QBFN</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-8 footer-bottom-left">
          <ul>
            <li>
              <router-link class="footer-links" to="/privacy">Privacy Policy</router-link>
            </li>
            <li>
              <router-link class="footer-links" to="/refund">Refund Policy</router-link>
            </li>

            <li>
              <router-link class="footer-links" to="/terms&conditions">Terms & Conditions</router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <ul class="footer-bottom-right">
            <li class="payment-option">
              <img src="/assets/images/visa-card.jpg" width="52" height="27" />
            </li>
            <li class="payment-option">
              <img src="/assets/images/master-card.jpg" width="52" height="27" />
            </li>
            <li class="payment-option">
              <img src="/assets/images/jazzcash.jpg" width="52" height="27" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section> -->

  <section class="site-footer" ref="footer">
    <loader :id="loaderId" :recaptcha-loader="showRecaptchaLoader" />
    <div class="site-footer-bg">
      <div class="site-footer-upper">
        <div class="container">
          <div class="">
            <div class="footer-body">
              <div class="col-sm-12 col-lg-4 logo-div">
                <div class="footer-logo">
                  <img src="/assets/images/os-images/footer-logo.png" alt="" width="170" height="75" />
                </div>
                <p>KIPS Online School delivers quality education, fostering global success through flexibility and inclusivity.</p>
              </div>
              <div class="col-sm-12 col-lg-4 usefull-links">
                <span>Useful Links</span>
                <ul>
                  <li><router-link to="/registration#enroll">Our School</router-link></li>
                  <li><router-link to="/registration">Registration</router-link></li>
                  <li><router-link to="/activities">Activities</router-link></li>
                  <li><router-link to="/portals">Portals</router-link></li>
                  <!-- <li>
                    <a :href="gotoPortal()" class="not-available">Portals</a>
                  </li> -->
                  <!-- <li><button @click="openExpertAdvicePopup()">Contact Us</button></li> -->
                  <li><router-link to="/registration#faq">FAQs</router-link></li>
                </ul>
              </div>
              <div class="col-sm-12 col-lg-4 newsletter">
                <!-- <span>Newsletter</span>
                <div class="email-btn">
                  <span class="email-icon"
                    ><svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.00002 16.2203L0.230017 18.3803C0.0775164 18.0203 -0.00123653 17.6316 1.46791e-05 17.2403V3.24016C1.46791e-05 2.77641 0.113766 2.32015 0.330002 1.91016L2.00004 3.46019L7.93002 8.97033L2.00002 16.2203ZM18.6002 10.3402L15.3602 13.3503C14.6002 14.0665 13.4152 14.0715 12.6501 13.3603L9.40017 10.3402L2.93994 18.2302L1.5899 19.8702C2.02117 20.1102 2.50617 20.2377 2.9999 20.2402H25.0001C25.4939 20.2377 25.9789 20.1102 26.4101 19.8702L25.0601 18.2302L18.6002 10.3402ZM14.0002 11.8903L24.3804 2.24024L26.2405 0.510237C25.8504 0.333986 25.4279 0.241486 25.0004 0.240234H3.00019C2.5727 0.241484 2.1502 0.333986 1.76018 0.510237L3.6202 2.24024L14.0002 11.8903ZM27.6704 1.91L26.0004 3.46003L20.0704 8.97017L26.0004 16.2202L27.7704 18.3802C27.9229 18.0202 28.0016 17.6315 28.0004 17.2402V3.24003C28.0004 2.77628 27.8866 2.31999 27.6704 1.91Z" fill="white" />
                    </svg>
                  </span>
                  <input type="email" v-model="email" placeholder="Enter your email id" />
                  <button @click="submitForm()" class="arrow-btn" :disabled="disableBtn">
                    <svg width="27" height="21" viewBox="0 0 27 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M26.5548 9.19328L18.04 0.678495C17.4557 0.0941467 16.5096 0.0941467 15.953 0.678495C15.3687 1.26284 15.3687 2.20893 15.953 2.76545L21.9357 8.77589L2.04 8.77589C1.23305 8.77589 0.565218 9.44371 0.565218 10.2507C0.565218 11.0576 1.23305 11.7255 2.04 11.7255L21.9357 11.7255L15.953 17.7081C15.3687 18.2924 15.3687 19.2385 15.953 19.795C16.2313 20.0733 16.6209 20.2402 17.0104 20.2402C17.4 20.2402 17.7617 20.1011 18.0678 19.795L26.5548 11.3081C26.833 11.0298 27 10.6402 27 10.2507C27 9.8611 26.833 9.47154 26.5548 9.19328Z" fill="white" />
                    </svg>
                  </button>
                </div> -->
                <div class="social-icons">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/KIPSOnlineSchool" target="_blank">
                        <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.499 0.00457742L8.64615 0C5.44104 0 3.36976 2.12507 3.36976 5.41417V7.91047H0.501322C0.442393 7.91047 0.384042 7.92208 0.329602 7.94464C0.275162 7.9672 0.2257 8.00026 0.184042 8.04194C0.142383 8.08362 0.109345 8.1331 0.0868153 8.18755C0.0642851 8.242 0.0527044 8.30036 0.0527344 8.35928V11.9761C0.0527344 12.0951 0.0999964 12.2092 0.184123 12.2933C0.268249 12.3775 0.382349 12.4247 0.501322 12.4247H3.36976V21.5512C3.36976 21.6702 3.41702 21.7843 3.50115 21.8684C3.58528 21.9525 3.69938 21.9998 3.81835 21.9998H7.56085C7.67982 21.9998 7.79392 21.9525 7.87805 21.8684C7.96217 21.7843 8.00944 21.6702 8.00944 21.5512V12.4247H11.3633C11.4823 12.4247 11.5964 12.3775 11.6805 12.2933C11.7646 12.2092 11.8119 12.0951 11.8119 11.9761L11.8133 8.35928C11.8132 8.24029 11.7658 8.1262 11.6817 8.04206C11.5975 7.95791 11.4835 7.91059 11.3645 7.91047H8.00944V5.79433C8.00944 4.77722 8.25181 4.26089 9.57674 4.26089L11.4986 4.26021C11.6175 4.26014 11.7315 4.21286 11.8156 4.12874C11.8997 4.04462 11.9469 3.93055 11.9469 3.81162V0.453165C11.9469 0.334311 11.8998 0.220315 11.8158 0.136208C11.7318 0.0521014 11.6179 0.00475934 11.499 0.00457742Z" fill="#0089D0" />
                        </svg>
                      </a>
                    </li>

                    <li>
                      <a href="https://www.instagram.com/kipsonlineschoolofficial/#" target="_blank">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 6.33203C7.97603 6.33203 6.33203 7.97603 6.33203 10C6.33203 12.024 7.97603 13.672 10 13.672C12.024 13.672 13.672 12.024 13.672 10C13.672 7.97603 12.024 6.33203 10 6.33203Z" fill="#0089D0" />
                          <path d="M15.536 0H4.464C2.004 0 0 2.004 0 4.464V15.536C0 18 2.004 20 4.464 20H15.536C18 20 20 18 20 15.536V4.464C20 2.004 18 0 15.536 0ZM10 16.48C6.428 16.48 3.52 13.572 3.52 10C3.52 6.428 6.428 3.524 10 3.524C13.572 3.524 16.48 6.428 16.48 10C16.48 13.572 13.572 16.48 10 16.48ZM16.616 4.7C15.86 4.7 15.244 4.088 15.244 3.332C15.244 2.576 15.86 1.96 16.616 1.96C17.372 1.96 17.988 2.576 17.988 3.332C17.988 4.088 17.372 4.7 16.616 4.7Z" fill="#0089D0" />
                        </svg>
                      </a>
                    </li>

                    <li>
                      <a href=" https://www.youtube.com/@Kipsonlineschoolofficial" target="_blank">
                        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M23.0645 2.0046C22.1982 0.974765 20.5987 0.554688 17.5441 0.554688H6.45569C3.33112 0.554688 1.70454 1.00186 0.841471 2.09827C0 3.16728 0 4.74238 0 6.92235V11.0774C0 15.3007 0.9984 17.445 6.45569 17.445H17.5442C20.1931 17.445 21.661 17.0743 22.6106 16.1654C23.5845 15.2335 24 13.7118 24 11.0774V6.92235C24 4.62338 23.9349 3.039 23.0645 2.0046ZM15.4081 9.5735L10.3729 12.2051C10.2549 12.2668 10.123 12.2971 9.98985 12.2929C9.85674 12.2887 9.72696 12.2503 9.61306 12.1813C9.49915 12.1123 9.40497 12.0151 9.33963 11.899C9.2743 11.783 9.24001 11.6521 9.24008 11.5189V6.27265C9.24008 6.13968 9.27434 6.00895 9.33954 5.89306C9.40474 5.77718 9.49869 5.68004 9.61234 5.611C9.72599 5.54197 9.8555 5.50337 9.98839 5.49893C10.1213 5.49448 10.2531 5.52434 10.3711 5.58563L15.4063 8.20024C15.532 8.26549 15.6373 8.36395 15.7109 8.48492C15.7845 8.60589 15.8236 8.74473 15.8237 8.88633C15.8239 9.02793 15.7853 9.16687 15.712 9.28802C15.6387 9.40918 15.5336 9.50792 15.4081 9.5735Z" fill="#0089D0" />
                        </svg>
                      </a>
                    </li>

                    <li>
                      <a href="https://wa.me/923409990494" target="_blank">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21.8182 4.18206C19.7374 2.08047 16.9741 0.791631 14.0267 0.548024C11.0792 0.304417 8.1418 1.12208 5.74416 2.85352C3.34653 4.58497 1.64654 7.11621 0.950833 9.99068C0.255128 12.8651 0.609508 15.8936 1.95005 18.5298L0.634141 24.9184C0.620487 24.982 0.6201 25.0477 0.633005 25.1115C0.64591 25.1752 0.671829 25.2356 0.70914 25.2889C0.763799 25.3697 0.841822 25.432 0.932788 25.4673C1.02375 25.5026 1.12334 25.5094 1.21823 25.4866L7.4796 24.0025C10.1084 25.3091 13.1155 25.6407 15.9658 24.9383C18.8161 24.2359 21.3248 22.545 23.0454 20.1665C24.766 17.7881 25.5871 14.8763 25.3623 11.9493C25.1376 9.02234 23.8818 6.27001 21.8182 4.18206ZM19.866 19.7639C18.4262 21.1996 16.5723 22.1473 14.5654 22.4735C12.5585 22.7996 10.4999 22.4879 8.67959 21.5821L7.80687 21.1502L3.96823 22.0593L3.9796 22.0116L4.77505 18.148L4.34778 17.3048C3.41769 15.4781 3.08958 13.404 3.41047 11.3794C3.73136 9.35489 4.68478 7.48385 6.13414 6.03434C7.95529 4.21375 10.425 3.19101 13.0001 3.19101C15.5751 3.19101 18.0448 4.21375 19.866 6.03434C19.8815 6.05212 19.8982 6.06883 19.916 6.08434C21.7145 7.90961 22.7186 10.3719 22.7092 12.9344C22.6999 15.4969 21.6778 17.9518 19.866 19.7639Z" fill="#0089D0" />
                          <path d="M19.5249 16.9298C19.0545 17.6707 18.3113 18.5776 17.3772 18.8026C15.7408 19.198 13.2295 18.8162 10.1045 15.9026L10.0658 15.8685C7.31811 13.3207 6.60447 11.2003 6.7772 9.51847C6.87266 8.56392 7.66811 7.70029 8.33857 7.13665C8.44456 7.04618 8.57026 6.98177 8.7056 6.94857C8.84094 6.91537 8.98217 6.9143 9.118 6.94544C9.25383 6.97658 9.38049 7.03907 9.48785 7.12792C9.59521 7.21676 9.68029 7.3295 9.73629 7.4571L10.7477 9.72983C10.8134 9.8772 10.8377 10.0397 10.8181 10.1998C10.7985 10.36 10.7356 10.5118 10.6363 10.6389L10.1249 11.3026C10.0152 11.4396 9.949 11.6063 9.93482 11.7813C9.92064 11.9563 9.95915 12.1315 10.0454 12.2844C10.3317 12.7866 11.0181 13.5253 11.7795 14.2094C12.634 14.9821 13.5817 15.6889 14.1817 15.9298C14.3423 15.9954 14.5188 16.0114 14.6885 15.9758C14.8583 15.9401 15.0134 15.8545 15.134 15.7298L15.7272 15.1321C15.8417 15.0192 15.984 14.9387 16.1397 14.8988C16.2954 14.8589 16.4589 14.861 16.6136 14.9048L19.0158 15.5866C19.1484 15.6273 19.2698 15.6977 19.3709 15.7925C19.4721 15.8873 19.5502 16.004 19.5993 16.1336C19.6484 16.2632 19.6673 16.4023 19.6544 16.5403C19.6415 16.6783 19.5972 16.8116 19.5249 16.9298Z" fill="#0089D0" />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="contacts">
                  <ul>
                    <li><a href="mailto:kos@school.kips.edu.pk">kos@school.kips.edu.pk</a></li>
                    <li><a href="tel:+923409990494">+92 340 9990494</a></li>
                    <li><a href="tel:+923450900376">+92 345 0900376</a></li>
                    <li><a href="tel:(042)111547775">(042) 111 547 775</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="site-footer-bottom">
      <div class="container">
        <div class="copy-terms">
          <div class="bottom-col">
            <!-- <span>Terms and Conditions - Privacy Policy</span> -->
          </div>
          <div class="bottom-col">
            <span>Copyright © 2025 KIPS Online School - All Rights Reserved.</span>
          </div>
          <div class="bottom-col">
            <div class="payments-logo">
              <img src="/assets/images/os-images/ubl-logo.png" alt="Logo" width="49" height="49" />
              <img src="/assets/images/os-images/visa-logo.png" alt="Logo" width="64" height="40" />
              <img src="/assets/images/os-images/mastercard-logo.png" alt="Logo" width="64" height="40" />

              <img src="/assets/images/os-images/jazzcash.png" alt="Logo" width="40" height="40" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import { blogs as blogsStoreKeys } from "../../store/keys";
import { servicesFactory } from "../../services/serviceFactory.js";
import { load } from "recaptcha-v3";

export default {
  data() {
    return {
      loaderId: "subscribe",
      disableBtn: false,
      showRecaptchaLoader: false,
      email: "",
      ToEmail: process.env.VUE_APP_CONTACT_US_TOEMAIL,
    };
  },
  computed: {
    ...mapGetters(blogsStoreKeys.namespace, blogsStoreKeys.getters),
  },
  methods: {
    submitForm() {
      this.disableBtn = true;
      this.showRecaptchaLoader = true;
      var bodyFormData = new FormData();
      bodyFormData.append("ToEmail", this.ToEmail);
      bodyFormData.append("Body", `<br><strong>Email: </strong>${this.email}`);
      bodyFormData.append("SendAsync", false);
      load(process.env.VUE_APP_RECAPTCHA_SITE_KEY, {
        autoHideBadge: true,
      })
        .then((recaptcha) => {
          recaptcha
            .execute("login")
            .then((token) => {
              this.showRecaptchaLoader = false;
              if (token) {
                let param = {
                  data: bodyFormData,
                  config: {
                    loader: {
                      show: true,
                      id: this.loaderId,
                    },
                  },
                };
                servicesFactory
                  .createService(servicesFactory.serviceType.enums.services.smtpService)
                  .EmailService.sendEmail(param, token)
                  .then((response) => {
                    this.$alertSuccess(response.message);
                    this.email = "";
                    grecaptcha.reset();
                    this.disableBtn = false;
                  })
                  .catch((ex) => {
                    if (ex.message) {
                      //this.$alertError(ex.message);
                      console.log(ex);
                    } else if (ex.exception) {
                      let messages = [];
                      for (var key of Object.keys(ex.exception)) {
                        messages.push(ex.exception[key][0]);
                      }
                      //  this.$alertError(messages);
                      console.log(messages);
                    }
                    this.disableBtn = false;
                  });
              }
            })
            .catch((err) => {
              //this.$alertError(err);
              console.log(err);
              this.disableBtn = false;
            });
        })
        .catch((err) => {
          //this.$alertError(err);
          console.log(err);
          this.disableBtn = false;
        });
    },
    gotoPortal() {
      return;
      return `${process.env.VUE_APP_PORTAL_URL}/dashboard`;
    },
    openExpertAdvicePopup() {
      Calendly.initPopupWidget({
        url: "https://calendly.com/kipsonlineschool/ask-a-question",
      });
      return false;
    },
  },
};
</script>
